import { AdminApi } from 'stylemix-vue-admin'
import {
  countryZone2DivisionAdapter,
  division2CountryZoneAdapter,
} from '../utils/adapters'

const divisionClient = new AdminApi('divisions')
const zoneClient = new AdminApi('zones')

export default {
  setCountryZones({ commit }, countryZones) {
    commit('setCountryZones', countryZones)
  },

  addCountryZone({ commit }, countryZone) {
    const divisionToStore = countryZone2DivisionAdapter(countryZone)
    return divisionClient.store(divisionToStore).then(response => {
      const countryZoneCreated = division2CountryZoneAdapter(response.data)
      commit('addCountryZone', countryZoneCreated)
      commit('setActiveCountryZone', countryZoneCreated)
    })
  },

  addInCountryZone({ commit }, inCountryZone) {
    const zoneToStore = countryZone2DivisionAdapter(inCountryZone)
    return zoneClient
      .removeParameter('division_id')
      .store({
        ...zoneToStore,
        division_id: inCountryZone.division_id,
      })
      .then(response => {
        const inCountryZoneCreated = division2CountryZoneAdapter(response.data)
        commit('addInCountryZone', inCountryZoneCreated)
        commit('setActiveInCountryZone', inCountryZoneCreated)
      })
  },

  removeCountryZone({ commit }, countryZoneForRemove) {
    const id =
      typeof countryZoneForRemove === 'object'
        ? countryZoneForRemove.id
        : countryZoneForRemove

    return divisionClient.destroy(id).then(() => {
      commit('removeCountryZone', countryZoneForRemove)
      commit('updateCountryZones', countryZoneForRemove)
      commit('unsetActiveCountryZone')
    })
  },

  removeInCountryZone({ commit }, inCountryZoneForRemove) {
    const id =
      typeof inCountryZoneForRemove === 'object'
        ? inCountryZoneForRemove.id
        : inCountryZoneForRemove

    return zoneClient.destroy(id).then(() => {
      commit('removeInCountryZone', inCountryZoneForRemove)
      commit('updateInCountryZones', inCountryZoneForRemove)
      commit('unsetActiveInCountryZone')
    })
  },

  toggleZoneManagerPanelVisibility({ commit }) {
    commit('toggleZoneManagerPanelVisibility')
  },

  setActiveCountryZone({ commit }, countryZone) {
    commit('setActiveCountryZone', countryZone)
  },

  unsetActiveCountryZone({ commit }) {
    commit('unsetActiveCountryZone')
  },

  setActiveInCountryZone({ commit }, inCountryZone) {
    commit('setActiveInCountryZone', inCountryZone)
  },

  unsetActiveInCountryZone({ commit }) {
    commit('unsetActiveInCountryZone')
  },

  updateCountryZones({ commit }, countryZone) {
    const divisionForUpdate = countryZone2DivisionAdapter(countryZone)
    return divisionClient
      .update(divisionForUpdate.id, divisionForUpdate)
      .then(response =>
        commit(
          'updateCountryZones',
          division2CountryZoneAdapter(response.data),
        ),
      )
  },

  updateInCountryZones({ commit }, inCountryZone) {
    const zoneForUpdate = countryZone2DivisionAdapter(inCountryZone)
    return zoneClient
      .removeParameter('division_id')
      .update(zoneForUpdate.id, {
        ...zoneForUpdate,
        division_id: inCountryZone.division_id,
      })
      .then(response =>
        commit(
          'updateInCountryZones',
          division2CountryZoneAdapter(response.data),
        ),
      )
  },

  fetchCountryZones({ commit }) {
    return divisionClient.all().then(response => {
      const countryZones = response.data.map(division =>
        division2CountryZoneAdapter(division),
      )
      commit('setCountryZones', countryZones)

      return countryZones
    })
  },

  fetchInCountryZones({ commit }, divisionId) {
    return zoneClient
      .setParameter('division_id', divisionId)
      .all()
      .then(response => {
        commit(
          'setInCountryZones',
          response.data.map(zone => division2CountryZoneAdapter(zone)),
        )
      })
  },
}
